module.exports = __webpack_public_path__ + "img/img5.fffe37aa.svg";